import { sum } from 'lib/array/arrayUtils'

function sumGroupedEarnableItemTotals(
  groupedEarnableItems: Array<App.Checkout.LoyaltyPointsEarnItem>,
): App.Checkout.LoyaltyPointsEarnItemTotals {
  return {
    defaultPayableItemPrice: sum(groupedEarnableItems.map(item => item.totals.defaultPayableItemPrice)),
    initialBasePoints: sum(groupedEarnableItems.map(item => item.totals.initialBasePoints)),
    initialStatusCredits: sum(groupedEarnableItems.map(item => item.totals.initialStatusCredits)),
    itemPromoDiscount: sum(groupedEarnableItems.map(item => item.totals.itemPromoDiscount)),
    pointsPaidInCurrency: sum(groupedEarnableItems.map(item => item.totals.pointsPaidInCurrency)),
    itemUnearnableCreditAmount: sum(groupedEarnableItems.map(item => item.totals.itemUnearnableCreditAmount)),
    earnableStatusCredits: sum(groupedEarnableItems.map(item => item.totals.earnableStatusCredits)),
    initialBonusStatusCredits: sum(groupedEarnableItems.map(item => item.totals.initialBonusStatusCredits)),
    earnableBonusStatusCredits: sum(groupedEarnableItems.map(item => item.totals.earnableBonusStatusCredits)),
    earnCap: groupedEarnableItems.map(item => item.totals.earnCap).find(earnCap => earnCap !== undefined),
    initialBonusPoints: sum(groupedEarnableItems.map(item => item.totals.initialBonusPoints)),
    earnableBasePoints: sum(groupedEarnableItems.map(item => item.totals.earnableBasePoints)),
    earnableBonusPoints: sum(groupedEarnableItems.map(item => item.totals.earnableBonusPoints)),
    earnablePoints: sum(groupedEarnableItems.map(item => item.totals.earnablePoints)),
    appliedRuleIds: groupedEarnableItems.flatMap(item => item.totals.appliedRuleIds),
    bonusPointsCampaignTypes: groupedEarnableItems.flatMap(item => item.totals.bonusPointsCampaignTypes ?? []),
    customRulesBreakdown: groupedEarnableItems.flatMap(item => item.totals.customRulesBreakdown ?? []),
  }
}

export function buildMergedOrderLoyaltyPendingPointsPayload(
  groupedEarnableItems: Array<App.Checkout.LoyaltyPointsEarnItem>,
  earnableItem: App.Checkout.LoyaltyPointsEarnItem,
  transactionKey: string,
  postPurchaseMode: boolean,
): App.OrderLoyaltyPendingPointsPayload {
  const mergedTotals = sumGroupedEarnableItemTotals(groupedEarnableItems)

  return {
    transactionKey,
    points: mergedTotals.earnableBasePoints,
    bonusPoints: mergedTotals.earnableBonusPoints,
    statusCredits: mergedTotals.earnableStatusCredits,
    bonusStatusCredits: mergedTotals.earnableBonusStatusCredits,
    appliedCustomRuleIds: mergedTotals.appliedRuleIds,
    ...(earnableItem.orderItemId && { itemId: earnableItem.orderItemId }),
    metadata: {
      itemId: earnableItem.itemId,
      orderItemId: earnableItem.orderItemId,
      itemTransactionKey: transactionKey,
      loyaltyGroupKey: earnableItem.loyaltyGroupKey,
      title: earnableItem.title,
      loyaltyProductType: earnableItem.loyaltyProductType,
      itemType: earnableItem.itemType,
      totals: mergedTotals,
      pointsEarnCalculation: earnableItem.pointsEarnCalculation,
      source: 'Web',
      purchaseMode: postPurchaseMode ? 'post-purchase' : 'order-creation',
    },
  }
}
